function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import Vue from "vue";
import AdvertiserInfoForm from "./index.vue";
export default Vue.extend({
    components: {
        AdvertiserInfoForm: AdvertiserInfoForm
    },
    data: function data() {
        return {};
    },
    computed: {
        advertiser: function advertiser() {
            return this.$store.state.advertiser;
        },
        dialogAttrs: function dialogAttrs() {
            var _this = this;
            return _objectSpread({
                style: {
                    paddingBottom: "15vh"
                },
                beforeClose: function(done) {
                    if (_this.advertiser.loading) {
                        _this.$message.info("\u63D0\u4EA4\u6570\u636E\u4E2D\uFF0C\u6682\u65E0\u6CD5\u5173\u95ED\u5F39\u7A97");
                    } else {
                        done();
                    }
                }
            }, this.advertiser.dialog);
        },
        visible: {
            get: function get() {
                return this.dialogAttrs.visible;
            },
            set: function set(val) {
                return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                    var ref;
                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                if (!(val === false && this.$refs.form)) {
                                    _ctx.next = 6;
                                    break;
                                }
                                ref = this.$refs.form;
                                ref.resetForm();
                                _ctx.next = 5;
                                return this.$store.dispatch("advertiser/resetInfo");
                            case 5:
                                // 更新表单
                                ref.updateForm();
                            case 6:
                                if (!(val === false)) {
                                    _ctx.next = 11;
                                    break;
                                }
                                _ctx.next = 9;
                                return this.$store.dispatch("advertiser/closeDialog");
                            case 9:
                                _ctx.next = 13;
                                break;
                            case 11:
                                _ctx.next = 13;
                                return this.$store.dispatch("advertiser/openDialog");
                            case 13:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, this);
                })).apply(this);
            }
        }
    },
    methods: {
        openDialog: function openDialog() {
            this.visible = true;
        },
        closeDialog: function closeDialog() {
            this.visible = false;
        },
        handleCancel: function handleCancel() {
            this.closeDialog();
        },
        handleSuccess: function handleSuccess() {
            this.closeDialog();
            this.$emit("save-success");
        }
    }
});
